import { render, staticRenderFns } from "./addRegRecord.vue?vue&type=template&id=596bdb22&scoped=true"
import script from "./addRegRecord.vue?vue&type=script&lang=js"
export * from "./addRegRecord.vue?vue&type=script&lang=js"
import style0 from "./addRegRecord.vue?vue&type=style&index=0&id=596bdb22&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "596bdb22",
  null
  
)

export default component.exports